import { Injectable } from '@angular/core';
import { HttpService } from '../http-service/http.service';
import { Utils } from '../../../../core/helpers/Utils';
import { Observable } from 'rxjs';
import { ServiceModule } from '../../../service.module';

@Injectable({ providedIn: ServiceModule })
export abstract class CrudService<T> {
    protected readonly ResourcePrefix = 'api';
    protected readonly APIUrl = `/${this.ResourcePrefix}/${this.getResourceUrl()}`;

    protected constructor(protected httpService: HttpService<T>) {}

	abstract getResourceUrl(): string;

	isMock() {
	    return window.location.href.includes('static=true') || Utils.isMock();
	}

	getList(path = ''): Observable<T[]> {
	    let url = `${this.APIUrl}/${path}`;
	    if (this.isMock()) {
	        url = `../assets/mock/${this.getResourceUrl()}.json`;
	    }
	    return this.httpService.getList(url);
	}

	get(id: string | number, query = ""): Observable<T> {
	    let url = `${this.APIUrl}/${id}${query}`;
	    if (this.isMock()) {
	        url = `../assets/mock/${this.getResourceUrl()}.json`;
	    }
	    return this.httpService.get(url);
	}

	add(path: string, id: string | number, resource: T): Observable<T> {
	    const url = `${this.APIUrl}${path}/${id}`;
	    return this.httpService.post(url, resource);
	}

	delete(path: string, id: string | number, query = ""): Observable<T> {
	    let url = `${this.APIUrl}${path}/${id}${query}`;
	    return this.httpService.delete(url);
	}

	update(path: string, id: string | number, resource: T): Observable<T> {
	    let url = `${this.APIUrl}${path}/${id}`;
	    return this.httpService.update(url, resource);
	}
}
